import {css} from 'lit';
import {tablet, desktop, smartphoneOnly} from '../../js/services/const';

export default css`
  :host {
    --tool-padding-top: 0;
    --tool-padding-right: 0;
    --tool-padding-bottom: 0;
    --tool-padding-left: 0;
    --tool-header-padding-top: 0;
    --tool-header-padding-right: 0;
    --tool-header-padding-bottom: 0;
    --tool-content-padding-top: 1rem;
    --tool-content-padding-right: 0;
    --tool-content-padding-bottom: 0;
    --tool-footer-padding-top: 14px;
    --tool-footer-padding-right: var(--gap);
    --tool-footer-padding-bottom: 7px;
    --tool-footer-padding-left: var(--gap);

    /** selector formally .mod-tool */
    position: relative;
    display: block;
    background-color: var(--base-system);
    clear: both;
    padding: var(--tool-padding-top) var(--tool-padding-right) var(--tool-padding-bottom);
  }

  .icon-arrow-left,
  .icon-arrow-right {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 2.4rem;
    height: 17.2rem;
    z-index: 1;
    background-color: transparent;
    line-height: 17.2rem;
    text-align: center;
    font-size: 2rem;
    color: var(--white);
    cursor: pointer;
  }

  .icon-arrow-left .solo,
  .icon-arrow-right .solo {
    display: none;
  }

  .icon-arrow-left:hover,
  .icon-arrow-right:hover {
    font-size: 2.4rem;
  }

  .icon-arrow-left.right,
  .icon-arrow-right.right {
    right: 0;
  }

  .icon-arrow-left.left,
  .icon-arrow-right.left {
    left: 0;
  }

  .tool-header {
    font-size: 1.4rem;
    line-height: 2.2rem;
    font-family: var(--font-family-sans-serif);
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: var(--tool-header-padding-top) var(--tool-header-padding-right) var(--tool-header-padding-bottom);
  }

  .tool-header .h4 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tool-header a {
    display: block;
    color: var(--text-highVisibility);
  }

  .tool-content {
    overflow: hidden;
    padding: var(--tool-content-padding-top) var(--tool-content-padding-right) var(--tool-content-padding-bottom);
  }

  /** When using external resources like dpa liveevent widgets, we use an iframe in the tool-body.
  Copy-paste from elements.less due to hard binding to article-xxx classes. */

  .tool-content iframe {
    border: 0;
    width: 100%;
    overflow: hidden;
    display: inherit;
    margin: 0 0 var(--gap) 0;
  }

  .tool-content iframe:not([height]) {
    height: 100%;
  }

  .tool-content .service-container li {
    padding: 0 !important;
  }

  .tool-content ul {
    display: block;
    margin: 0;
    padding: 0;
  }

  .tool-content ul li {
    display: list-item;
  }

  .tool-content ul li:before {
    content: '';
    display: none;
    padding: 0;
    margin: 0;
  }

  .tool-footer {
    font-size: 1.4rem;
    line-height: 2.2rem;
    text-align: right;
    color: var(--text-highVisibility);
    cursor: pointer;
    padding: var(--tool-footer-padding-top) var(--tool-footer-padding-right) var(--tool-footer-padding-bottom) var(--tool-footer-padding-left);
  }

  .tool-footer slot[name=footer]::slotted(a) {
    color: var(--text-highVisibility) !important;
    display: block;
    line-height: 3.6rem;
  }

  .tool-footer slot[name=footer]::slotted(a:hover) {
    color: var(--system-hyperlink) !important;
  }

  :host[data-mod-name='sporttickertool'] .tool-header {
    --tool-header-padding-bottom: 2rem;
  }

  .tool-header .icon-thin-arrow-next {
    content: '\e601';
    font-family: 'icons';
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1.4rem;
    line-height: 2.2rem;
    position: static;
    height: auto;
    width: auto;
    color: var(--text-highVisibility);
  }

  @media (max-width: ${smartphoneOnly}px) {
    :host {
      border: 0;
    }

    :host[data-mod-name='sporttickertool'] .tool-footer {
      /* smartphone only */
      --tool-footer-padding-left: 0;
      --tool-footer-padding-right: 0;
    }
  }

  @media (min-width: ${tablet}px) {
    :host {
      /* selector formally .mod-tool */
      box-shadow: var(--box-shadow);
      --tool-padding-top: 2.6rem;
      --tool-padding-right: 3rem;
      --tool-padding-bottom: 2.6rem;
      --tool-content-padding-top: 2rem;
    }

    .tool-header {
      font-size: 1.8rem;
    }

    .icon-arrow-left,
    .icon-arrow-right {
      width: 4rem;
    }

    .tool-header,
    .tool-content {
      line-height: unset;
      min-height: 0;
    }

    .tool-header a {
      display: inline;
    }

    .tool-header a:hover {
      color: var(--system-hyperlink);
    }

    :host[data-mod-name='sporttickertool'] .tool-header {
      --tool-header-padding-top: 2rem;
      --tool-header-padding-right: 1.6rem;
    }
  }

  @media (min-width: ${desktop}px) {
    .tool-header .block__label {
      border-bottom: 0;
    }
  }
`;
